import React, { useState, useEffect } from 'react';

import RecommendedAccessories from '@hpstellar/pdp/RecommendedAccessories';

import withPageComponents from '../../../page/components/with-page-components';
import Icon from '../../../ui/components/icon';
import { getProductClickMetrics } from '../../../metrics/metrics-helpers';
import { Helpers } from '../../../core/src/helpers';
import useAddToCart from '../../../hooks/useAddToCart';
import useProductPrice from '../../../hooks/useProductPrice';

import './cross-sell.less';

const { memoize } = Helpers;

const PDP_XSELL_LIST_EVENT = 'pdp-accessories';

/*To do: look into tracking. old method might not apply anymore*/
const trackPdpCrossSellMetrics = (product, position, trackCustomMetric) => {
    try {
        let productClickMetrics = getProductClickMetrics({ product, position, list: PDP_XSELL_LIST_EVENT });
        trackCustomMetric('productClick', productClickMetrics);
    } catch (e) {}
};

const mapAccessories = (products, prices = {}) => {
    return products.reduce((xsell, product, idx) => {
        const { name, images, sku, linkUrl, ksps, attributes = {} } = product;
        const { prdOverview } = attributes;
        const descriptionBackup = ksps.join(', ');
        const { regularPrice, salePrice, ctaText, isOOS, locale, currency } = prices[sku] || {};
        xsell.push({
            name,
            sku,
            url: linkUrl,
            image: {
                url: images[0].lrg,
            },
            description: prdOverview || descriptionBackup,
            price: {
                regularPrice,
                salePrice,
                locale,
                currency,
                priceDifference: regularPrice - salePrice,
            },
            attachBtnText: (isOOS || salePrice === '') ? 'out of stock' : ctaText,
        });
        return xsell;
    }, []);
};

const pdpCrossSell = ({ product, pdpCrossSell, trackCustomMetric }) => {
    const { sku } = product || {};
    const { relatedProducts, categories } = pdpCrossSell || {};
    const [selectCat, setSelectCat] = useState(null);
    const { addToCart } = useAddToCart();
    const { prices } = useProductPrice(relatedProducts);

    useEffect(() => {
        if (categories) {
            setSelectCat(categories[0]._id);
        }
    }, [categories]);

    const onAddtoCart = sku => {
        const product = relatedProducts.filter(product => product.sku === sku)[0];
        addToCart(product, 1, false, undefined, undefined, sku, PDP_XSELL_LIST_EVENT, { list: PDP_XSELL_LIST_EVENT });
    };

    const translations = {
        addToBasket: 'add to cart',
    };

    const filteredProducts = memoize(
        (index, products, categories) => {
            if (categories.length === 0) {
                return products;
            }
            return products.filter((product, i) => product.categories.filter(cat => cat._id === selectCat).length > 0);
        },
        (index, categories) => {
            const products = (pdpCrossSell || {}).relatedProducts;
            return `${index}-${products.length}`;
        }
    );

    if (relatedProducts && relatedProducts.length > 0) {
        const mappedCategories = categories.map(category => {
            category.title = category.displayName;
            category.id = category._id;
            category.icon = <Icon name={category.iconName} size={50} />;
            return category;
        });

        const categoryProducts = filteredProducts(selectCat, relatedProducts, categories);
        const accessories = mapAccessories(categoryProducts, prices, addToCart, trackCustomMetric, sku);

        return (
            <RecommendedAccessories
                translations={translations}
                title="Recommended Accessories"
                locale="en-US"
                currency="USD"
                categories={mappedCategories}
                onCategoryChange={categoryId => setSelectCat(categoryId)}
                onAdd={productSku => onAddtoCart(productSku)}
                addToCardTimeout={3000}
                products={accessories}
                className="pdp-recommended-accessories-section"
            />
        );
    }
    return null;
};
export default withPageComponents(pdpCrossSell, { components: ['pdpCrossSell', 'product'] });
